import { Injectable } from '@angular/core';
import { ViewType } from '@thehubz/client/core';
import { AnyType, AssetGridView } from '@thehubz/shared/model';

export interface GridConfig {
  showListView?: boolean;
  showGridView?: boolean;
  showGridViewSmall?: boolean;
  showGridViewLarge?: boolean;
  showGridViewSidebar?: boolean;
  gridSize?: number;
}

@Injectable({ providedIn: 'root' })
export class AssetViewTypeService {
  private static SESSION_KEY = 'gridObject';

  setGridConfig(suffix: string, config: GridConfig) {
    const gridSettingsKey = AssetViewTypeService.SESSION_KEY + suffix;
    const sessionGridObject = JSON.parse(sessionStorage[gridSettingsKey] ?? '{}');
    sessionStorage.setItem(gridSettingsKey, JSON.stringify({ ...sessionGridObject, ...config }));
  }

  getGridConfig(suffix: string): GridConfig {
    const gridSettingsKey = AssetViewTypeService.SESSION_KEY + suffix;
    try {
      return sessionStorage[gridSettingsKey] ? JSON.parse(sessionStorage[gridSettingsKey]) : {};
    } catch (err) {
      sessionStorage.removeItem(gridSettingsKey);
      return {};
    }
  }

  getGridSettings(name: ViewType, suffix = '') {
    const gridSettings: AnyType = this.getGridConfig(suffix);
    return gridSettings[name];
  }

  getViewType(suffix = ''): ViewType {
    const sessionGridObject: AnyType = this.getGridConfig(suffix);
    for (const property in sessionGridObject) {
      if (
        [AssetGridView.GridView.SHOW_LIST_VIEW, AssetGridView.GridView.SHOW_GRID_VIEW_SMALL, AssetGridView.GridView.SHOW_GRID_VIEW_LARGE].includes(property)
      ) {
        if (sessionGridObject[property]) {
          switch (property) {
            case AssetGridView.GridView.SHOW_LIST_VIEW: {
              return 'list';
            }
            case AssetGridView.GridView.SHOW_GRID_VIEW_SMALL: {
              if (sessionGridObject[AssetGridView.GridView.SHOW_GRID_VIEW_SIDEBAR]) {
                return 'grid_3';
              }
              return 'grid_4';
            }
            case AssetGridView.GridView.SHOW_GRID_VIEW_LARGE: {
              if (sessionGridObject[AssetGridView.GridView.SHOW_GRID_VIEW_SIDEBAR]) {
                return 'grid_6';
              }
              return 'grid_8';
            }
          }
        }
      }
    }
    return 'grid_4';
  }
}
